
import { QueryClient, QueryCache } from 'react-query';


const createReactQueryClient = () => new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: ((failureCount, error) => {
        if (error?.status === 404) {
          return false;
        }
        return failureCount < 2;
      }),
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      console.error(`Something went wrong in the ${query.queryKey[0]} query: ${error.message}`);
    },
  }),
});

export default createReactQueryClient;
